import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading fixtures...' 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-6 sm:py-8">
      <div className="bg-gradient-to-br from-blue-600 to-indigo-600 p-2.5 rounded-2xl mb-3 shadow-lg">
        <Loader2 className="h-8 w-8 text-white animate-spin" />
      </div>
      <p className="text-gray-700 dark:text-gray-300 text-lg font-medium">{message}</p>
    </div>
  );
};